export enum Currency {
    REAL = "brl",
    DOLLAR = "usd",
}

export enum PlanPaymentInterval {
    MONTHLY = "monthly",
    YEARLY = "yearly",
}

export interface IPlanPrice {
    currency: Currency;
    price: number;
    interval: PlanPaymentInterval;
    gatewayId?: string;
}

export interface IPlan {
    _id: string;
    name: ILanguage;
    description: ILanguage;
    free: boolean;
    prices: IPlanPrice[];
    features: ILanguage[];
    featured: boolean;
    maxUsage: {
		[PlanPermissions.CUSTOMERS]: number
		[PlanPermissions.PRODUCTS]: number
		[PlanPermissions.REWARDS]: number
		[PlanPermissions.APPLICATIONS]: number
	}
    updatedAt: Date;
    createdAt: Date;
    deletedAt?: Date;
}

export enum PlanPermissions {
    CUSTOMERS = "customers",
    PRODUCTS = "products",
    REWARDS = "rewards",
    APPLICATIONS = "applications",
}
